<app-auth-container>
  <form
    *ngIf="!isVerify"
    [formGroup]="signUpForm"
    (ngSubmit)="onNext()"
    class="container-details flex flex-col items-center p-4"
  >
    <div
      class="signUp-heading-details flex justify-center items-center nowrap gap-2"
    >
      <p class="signUp-heading">Sign Up</p>
      <div class="logo">
        <img src="assets/images/signup_image.svg" alt="Logo" loading="lazy" />
      </div>
    </div>

    <div class="signUp-details flex justify-center items-center flex-col">
      <!-- Name Field -->
      <div class="signUp-field">
        <div class="signUp-label">
          <label for="name">Your Name</label>
        </div>
        <div class="input-container flex items-center flex-nowrap">
          <div class="input-icon">
            <img
              src="assets/images/account_circle.svg"
              alt="Account_icon"
              *ngIf="!isFieldValid('name')"
              loading="lazy"
            />
            <img
              src="assets/images/account_circle_green.svg"
              alt="Account_icon"
              *ngIf="isFieldValid('name')"
              loading="lazy"
            />
          </div>
          <div class="w-100">
            <input
              class="border-none outline-none bg-transparent"
              type="text"
              id="name"
              placeholder="Enter here"
              formControlName="name"
            />
          </div>
        </div>
        <div *ngIf="isFieldInvalid('name')" class="error-message">
          <span *ngIf="signUpForm.get('name')?.errors?.['required']">
            Name is required.
          </span>
        </div>
      </div>

      <!-- Birthday Field -->
      <div class="signUp-field">
        <div class="signUp-label">
          <label for="birthday">Birthday</label>
        </div>
        <div class="input-container flex items-center flex-nowrap">
          <div class="input-icon">
            <img
              src="assets/images/calendar_month.svg"
              alt="calendar_icon"
              *ngIf="!isFieldValid('birthday')"
              loading="lazy"
            />
            <img
              src="assets/images/calendar_month_green.svg"
              alt="calendar_icon"
              *ngIf="isFieldValid('birthday')"
              loading="lazy"
            />
          </div>
          <div class="w-100">
            <input
                class="border-none outline-none bg-transparent"
                type="text"
                id="DOB"
                placeholder="MM-DD-YYYY"
                formControlName="birthday"
              />
          </div>
        </div>
        <div *ngIf="isFieldInvalid('birthday')" class="error-message">
          <span *ngIf="signUpForm.get('birthday')?.errors?.['required']">
            Birthday is required.
          </span>
          <span *ngIf="signUpForm.get('birthday')?.errors?.['inValidMaxAge']">
            Please enter a valid age.
          </span>
          <span *ngIf="signUpForm.get('birthday')?.errors?.['inValidMinAge']">
            Please enter a valid age.
          </span>
        </div>
      </div>

      <div class="signUp-field">
        <div class="signUp-label">
          <label>Country</label>
        </div>
        <div class="input-container flex items-center flex-nowrap">
          <div class="input-icon">
            <svg style="opacity: .7;" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 21C15.5 17.4 19 14.1764 19 10.2C19 6.22355 15.866 3 12 3C8.13401 3 5 6.22355 5 10.2C5 14.1764 8.5 17.4 12 21Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g>
            </svg>
          </div>
          <div class="w-100" style="min-width: 0;">
            <ng-select formControlName="country" [disabled]="signUpForm.disabled" [clearable]="false">
              <ng-option value="" disabled>Select Country</ng-option>
              @for (country of countriesList; track country.code) {
                  <ng-option [value]="country.name">{{country.name}}</ng-option>
              }
            </ng-select>
          </div>
        </div>
        <small *ngIf="formSubmitted && !signUpForm.get('country')?.value" class="error-message">
          <span >Country is required</span>
        </small>
      </div>

      <!-- Email Field -->
      <div class="signUp-field">
        <div class="signUp-label">
          <label for="email">Email Address</label>
        </div>
        <div class="input-container flex items-center flex-nowrap">
          <div class="input-icon">
            <img
              src="assets/images/alternate_email.svg"
              alt="email_icon"
              *ngIf="!isFieldValid('email')"
              loading="lazy"
            />
            <img
              src="assets/images/alternate_email_green.svg"
              alt="email_icon"
              *ngIf="isFieldValid('email')"
              loading="lazy"
            />
          </div>
          <div class="w-100">
            <input
              class="border-none outline-none bg-transparent"
              type="email"
              id="email"
              placeholder="Enter here"
              formControlName="email"
            />
          </div>
        </div>
        <div *ngIf="isFieldInvalid('email')" class="error-message">
          <span *ngIf="signUpForm.get('email')?.errors?.['required']">
            Email is required.
          </span>
          <span *ngIf="signUpForm.get('email')?.errors?.['email']">
            Invalid email format.
          </span>
        </div>
      </div>

      <!-- Phone Number Field -->
      <div class="signUp-field">
        <div class="signUp-label">
          <label for="phone">Phone Number (Optional)</label>
        </div>
        <div class="input-container flex items-center flex-nowrap">
          <div class="input-icon">
            <img
              [src]="
                signUpForm.get('phone')?.value?.length === 0 ||
                !signUpForm.get('phone')?.value ||
                !isFieldValid('phone')
                  ? 'assets/images/call.svg'
                  : 'assets/images/call_green.svg'
              "
              alt="phone_icon"
              loading="lazy"
            />
          </div>
          <div class="w-100 country-select flex dialCodeField" [class.empty]="!selectedDialCode">
            <ng-select [style.minWidth]="selectedDialCode ? '6ch': '5ch'" [clearable]="true" [(ngModel)]="selectedDialCode" [ngModelOptions]="{ standalone:true}">
              @for (code of uniqueAvailableCodes; track code) {
                  <ng-option [value]="code">{{code}}</ng-option>
              }
            </ng-select>
            <!-- <lib-country-list
              placeholderText="+XX"
              [selectedCountryConfig]="dialCodeListConfig"
              [allowedCountryCodes]="['in']" 
              [countryListConfig]="dialCodeListConfig"
              (onCountryChange)="onDialCodeChange($event)">
            </lib-country-list> -->
            <span style="z-index: 1;">|</span>
            <input
              class="border-none outline-none bg-transparent"
              style="margin-left: .5em;"
              type="text"
              id="phone"
              placeholder="Enter here"
              formControlName="phone"
              (input)="onPhoneNumberChange($event)"
              #phoneInput
            />
            <span class="clear-btn" title="Remove Phone Number" role="button" style="margin-bottom: 0;" (click)="resetPhone()">
              <svg width="22px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M8 8L16 16" stroke="#A4A4A4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M16 8L8 16" stroke="#A4A4A4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
            </span>
          </div>
        </div>
        <!-- Display error message only if field is not empty and invalid -->
        <div
          class="error-message"
          *ngIf="(signUpForm.get('phone')?.touched || signUpForm.get('phone')?.dirty) && signUpForm.get('phone')?.errors?.['minlength'] || signUpForm.get('phone')?.errors?.['maxlength']"
        >
          <small *ngIf="signUpForm.get('phone')?.errors?.['minlength']">Phone number must have atleast 6 digits.</small>
          <small *ngIf="signUpForm.get('phone')?.errors?.['maxlength']">Phone number cannot have more than 15 digits.</small>
        </div>
        <small class="error-message" *ngIf="dialCodeOrPhoneMissing && !signUpForm.get('phone')?.value">Please enter a valid phone number</small>
        <small class="error-message" *ngIf="dialCodeOrPhoneMissing && !selectedDialCode">Please select a dial code.</small>
      </div>
    </div>

    <!-- Terms and Privacy -->
    <div class="termsAndprivacy-container flex flex-col mt-2 w-100 gap-1">
      <div class="terms-main flex items-center justify-start gap-2">
        <div class="flex">
          <input type="checkbox" id="terms" formControlName="terms" />
        </div>
        <div>
          <label for="terms">I read and agree to </label>
          <a
            [routerLink]="['/terms-and-conditions']"
            rel="noopener noreferrer"
            class="cursor-pointer pol-term"
            >Terms & Conditions</a
          >
        </div>
      </div>
      <div class="privacy-main flex items-center justify-start gap-2">
        <div class="flex">
          <input type="checkbox" id="privacy" formControlName="privacy" />
        </div>

        <div>
          <label for="privacy">I read and accept the </label>
          <a
            href="/privacy"
            target="_blank"
            rel="noopener noreferrer"
            class="cursor-pointer pol-term"
          >
          Privacy Policy
          </a>
        </div>
      </div>

      <!-- <div style="display: flex;margin-top: .5em;">
        <svg style="min-width: 1rem;align-self: self-start;" width="1rem" viewBox="0 0 24 24" id="magicoon-Regular" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <defs> <style>.cls-1{fill:#41416e;}</style> </defs> <title>exclamation-circle</title> <g id="exclamation-circle-Regular"> <path id="exclamation-circle-Regular-2" data-name="exclamation-circle-Regular" class="cls-1" d="M12,2.25A9.75,9.75,0,1,0,21.75,12,9.761,9.761,0,0,0,12,2.25Zm0,18A8.25,8.25,0,1,1,20.25,12,8.259,8.259,0,0,1,12,20.25ZM13,16a1,1,0,1,1-1-1A1,1,0,0,1,13,16Zm-1.75-4V8a.75.75,0,0,1,1.5,0v4a.75.75,0,0,1-1.5,0Z"></path> </g> </g></svg>
        <div style="display: block;">
          <p style="font-size: 12px;">We are working to add other countries not on the list.</p>
          <p style="font-size: 12px;">Kindly use email address to login in the meantime.</p>
        </div>
      </div> -->
    </div>

    <!-- Next Button -->
    <div class="button mt-4 cursor-pointer">
      <button class="btn-default cursor-pointer" type="submit">Next</button>
    </div>

    <!-- Already Have an Account -->
    <div class="alreadyuser cursor-pointer" (click)="onSignUp()">
      <p>Already have an account? <span>Sign In</span></p>
    </div>
  </form>
  <app-otp-verification
    *ngIf="isVerify"
    [email]="signUpForm.value.email"
    [phoneNumber]="signUpForm.value.phone"
    btnText="Sign Up"
    [isLoginOrSignup]="true"
    (dataEvent)="receiveData($event)"
    [isStaySignedIn]="true"
  />
</app-auth-container>
